import React from "react";
import { injectIntl } from "react-intl";
import "./countdownTimer.scss";

const CountdownTimer = ({
  intl: { messages },
  seconds,
  handleResend,
  expirationDate,
}) => {

  return (
    <div className="d-flex justify-content-center align-items-center countdown-wrapper">
      <p className="mb-0">
        {seconds}
        <small className="mx-2">{messages.common.second}</small>
      </p>
      <button
        className="btn countdown-wrapper_btn"
        disabled={
          seconds ||
          (expirationDate &&
            new Date().getTime() < new Date(expirationDate).getTime())
        }
        onClick={handleResend}
      >
        {messages.common.resend}
      </button>
    </div>
  );
};
export default injectIntl(CountdownTimer);
